const data=[{
    name:"Dr.Pradyuman Reddy",
    e1:"MBBS, DNB (GEN Medicine)",
    e2:"PGCC Rheumatology",
    e3:"Consulting Physician",
    e4:"15 Years Experienced"

},
{
    name:"Dr. CB Oak",
    e1:"MBBS, MD (Medicine)",
    e2:"Intensivist and Diabetologist",
    e3:"Consulting Physician",
    e4:"15 Years Experienced"

},
{
    name:"Dr. Abhishek Jain",
    e1:"MBBS, MD (Medicine)",
    e2:"Intensivist and Diabetologist",
    e3:"Consulting Physician",
    e4:"15 Years Experienced"

},
{
    name:"Dr. Amit Jain",
    e1:"MBBS",
    e2:"PGDCC (Cardiology)",
    e3:"Intensivist and Diabetologis",
    e4:"15 Years Experienced"

},
{
    name:"Dr. DP Nema",
    e1:"BAMS",
    e2:"",
    e3:"",
    e4:"40 Years Experienced"

},
{
    name:"Dr. Banthiya",
    e1:"DM Cardiologist",
    e2:"",
    e3:"",
    e4:"30 Years Experienced"

},
{
    name:"Dr. Afraz Khan",
    e1:"BAMS",
    e2:"",
    e3:"",
    e4:"10 Years Experienced"

},

{
    name:"Dr. Anushree Nema",
    e1:"MBBS",
    e2:"",
    e3:"",
    e4:"5 Years Experienced"

},
{
    name:"Akshok One Hospital",
    e1:"",
    e2:"",
    e3:"",
    e4:"Dahisar Est Mumbai"

},
{
    name:"Shalom Life Care",
    e1:"",
    e2:"",
    e3:"",
    e4:"Mumbai"

},
{
    name:"Accurate Health Care Path Labs",
    e1:"",
    e2:"",
    e3:"",
    e4:"Pune, Mumbai"

},
{
    name:"Dalvi Nursing Home ",
    e1:"",
    e2:"",
    e3:"",
    e4:"Chunabhatti, Mumbai"

}

]
export default data